import React from 'react'
import { RouteObject, Navigate } from 'react-router-dom'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { AuthGuard } from '@components/guards/AuthGuard'
import { MainLayout } from '@components/layout/MainLayout'
import { lazyPage, lazyWithSuspense } from '@app/utils/routeUtils'
import { MkAvailTable } from '@components/core'
import { TestRoutes } from '../../../test-pages/routes'

const AvailTableGuard: React.FC = () => {
  const { chSwitchAvailTable } = useFlags()
  if (chSwitchAvailTable === undefined) return null
  if (!chSwitchAvailTable) return <Navigate to="/" replace />
  return <MkAvailTable />
}

// Lazy load misc components when they're needed

/**
 * Miscellaneous routes that don't fit into other categories
 * Includes home page, general routes, etc.
 */
export const miscRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <MainLayout
        themeSwitcher
        promoHeader
      />
    ),
    children: [
      // Commented routes below can be uncommented as needed
      {
        index: true,
        // const MkPageHome = lazy(() => import('@pages/MkPageHome'))
        element: (
          <Navigate
            to="/account"
            replace
          />
        ),
      },
      {
        path: 'register',
        // const MkPageRegister = lazy(() => import('@pages/register/MkPageRegister'))
        element: lazyPage('MkPageRegister', 'register'),
      },
      {
        path: 'login',
        // element: lazyWithSuspense(() => import('@pages/account/MkPageLogin')),
        element: lazyPage('MkPageLogin', 'account'),
      },
      {
        path: 'account-switch',
        element: <AuthGuard>{lazyPage('MkAccountSwitch', 'account')}</AuthGuard>,
      },
      {
        path: 'logout',
        element: lazyWithSuspense(() =>
          import('@auth/components/LogoutCallback/LogoutCallback').then((module) => ({
            default: module.LogoutCallback,
          })),
        ),
      },
      {
        path: 'mako/availTable',
        element: <AvailTableGuard />,
      },
      {
        path: 'test/*',
        element: <TestRoutes />,
      },
    ],
  },
]
